import { Heart } from 'lucide-react';
import { useFavorites } from '../contexts/FavoritesContext';
import { toast } from 'sonner';

const FavoriteButton = ({ business, size = 'default', showText = false }) => {
  const { isFavorite, toggleFavorite } = useFavorites();
  const isLiked = isFavorite(business.id);

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    toggleFavorite(business);
    
    if (!isLiked) {
      toast.success(`Added ${business.name} to favorites`);
    } else {
      toast.success(`Removed from favorites`);
    }
  };

  const sizeClasses = {
    small: 'w-4 h-4',
    default: 'w-5 h-5',
    large: 'w-6 h-6'
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center gap-1.5 p-2 rounded-lg transition-all ${
        isLiked 
          ? 'text-red-500 hover:text-red-600' 
          : 'text-muted-foreground hover:text-red-500'
      }`}
      aria-label={isLiked ? 'Remove from favorites' : 'Add to favorites'}
      data-testid={`favorite-btn-${business.id}`}
    >
      <Heart 
        className={`${sizeClasses[size]} transition-transform ${isLiked ? 'fill-current scale-110' : ''}`} 
      />
      {showText && (
        <span className="text-sm">{isLiked ? 'Saved' : 'Save'}</span>
      )}
    </button>
  );
};

export default FavoriteButton;
